import * as actions from "../actions"

import { getUrl } from "./mangrove"

export function setLoader(counter) {
  return async function (dispatch) {
    dispatch({ type: actions.LOADING_STATE, loading: counter })
  }
}

export function getAppInfo(server, appname, parameters) {
  const functionName = `${appname}.appfunctions.getAppInfo`
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        dispatch(setAppInfoInState(json))
        return json
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getAppInfo`, type: "error", duration: 4000 } })
      })
  }
}

export function sendPushNotification(server, appname, parameters) {
  const functionName = `${appname}.appfunctions.SendPushToTopic`
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        if (json.exception) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${json.exception} in function sendPushNotification`, type: "error", duration: 4000 } })
        } else {
          return json
        }
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function sendPushNotification`, type: "error", duration: 4000 } })
      })
  }
}

export function setOrderId(server, appname, parameters) {
  const functionName = `${appname}.appfunctions.SetOrderId`
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        if (json.exception) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${json.exception} in function setOrderId`, type: "error", duration: 4000 } })
        } else {
          return json
        }
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function setOrderId`, type: "error", duration: 4000 } })
      })
  }
}

export function setCategory(server, appname, parameters) {
  const functionName = `${appname}.appfunctions.SetCategory`
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        if (json.exception) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${json.exception} in function setCategory`, type: "error", duration: 4000 } })
        } else {
          return json
        }
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function setCategory`, type: "error", duration: 4000 } })
      })
  }
}

export function setAppInfoInState(appinfo) {
  return {
    type: actions.SET_APP_INFO,
    appinfo
  }
}
